const dataFilePath = 'data/covid-cases.json';
const riskDataFilePath = 'data/risk_by_postcode.json';
const suburbDataFilePath = 'data/suburb_names_by_postcode.json';

const dataURLs = {
    data: `${process.env.PUBLIC_URL}/${dataFilePath}`,
    riskData: `${process.env.PUBLIC_URL}/${riskDataFilePath}`,
    suburbData: `${process.env.PUBLIC_URL}/${suburbDataFilePath}`,
};

export const getCasesData = () =>
    fetch(dataURLs.data).then(response => response.json());

export const getRiskData = () =>
    fetch(dataURLs.riskData).then(response => response.json());

export const getSuburbByPostcodeData = () =>
    fetch(dataURLs.suburbData).then(response => response.json());





// WEBPACK FOOTER //
// ./src/api/index.js